import ReactQuill from 'react-quill';

const BlockEmbed = ReactQuill.Quill.import('blots/block/embed');

class VerticalLine extends BlockEmbed {
  static create() {
    let node = document.createElement('hr'); // Используем div вместо hr для вертикальной линии
    node.setAttribute('vertical-line', 'vertical-line'); // добавляем атрибут
    node.classList.add('vertical-line'); // добавляем класс
    return node;
  }
}
VerticalLine.blotName = 'vertical-line';
VerticalLine.tagName = 'hr';

export default VerticalLine;
